export default __webpack_public_path__ + "static/media/time_management.198c7df6.svg";